
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';
import { DecodeHtml } from '../../utils/decodeHtml';
const History = () => {



    const state = useSelector(state => state.aboutUnitenContent)
    


    const aboutUniten = state?.data?.properties

    const title = aboutUniten?.title
    const description = DecodeHtml({ html: aboutUniten?.richTextContent?.markup })


    // const images = [
    //     "/assets/aboutMainCampus2.svg",
    //     "/assets/history3.svg",
    //     "/assets/history2.svg",


    // ]
    // const paragraphs = [
    //     `With the proclamation of Vision 2020, Tenaga Nasional Berhad(TNB) felt that there was a great necessity for a revision of what top notch human capital development is, specifically in the areas of engineering and management and its social obligation towards nation building.`,

    //     `Therefore in 1994, the top man at TNB at the time, Tan Sri Dato’ (Dr.) Ani Arope envisioned that Institut Latihan Sultan Ahmad Shah(ILSAS), the training arm of TNB, would be upgraded to Institut Kejuruteraan Teknologi Tenaga Nasional(IKATAN).Consequently, personnel training and development were then increased to diploma, bachelors and masters levels.`,

    //     `One of the approaches utilised to meet those ends was the running of twinning programmes with world renowned higher learning institutions such as Indiana University - Purdue University Indianapolis(IUPUI), Ohio University, Lincoln University and Universiti Malaya.`,

    //     `In the late 1990s, however, this region was seriously affected by the Asian financial crisis.Due to the austerity measures taken to soften the financial blow to the country, this unfortunate event led to the government’s decision to scale down on the number of scholarships given out to outstanding students intending to pursue their higher education in top British and American universities.This, in turn, resulted in a shortage of available places in public universities.`,

    //     `To overcome this, the then Minister of Education, Dato’ Sri Mohd.Najib Tun Abdul Razak, invited TNB and two other government - linked companies to set up their own private universities.TNB duly excepted the challenge and in 1997, IKATAN was upgraded to Universiti Tenaga Nasional to become one of the first privately funded higher learning institution in the country.And it has never looked back since.`,

    //     `The UNITEN Putrajaya campus, in effect, began to take shape in 1995. Involving three stages of development and construction covering an area of 483 acres, it was the beginning of a quest to fulfil the hopes of a nation.Its close proximity to the Multimedia Super Corridor(MSC) and the federal administrative centre Putrajaya simply added to UNITEN’s air of auspiciousness.According to Dr.Tajul Arus bin Noh, the first Rector of UNITEN, “The university’s primary mission is to provide quality education and training in engineering, information technology, business and related fields for Malaysians and other nationals.”`,

    //     `By 1999, student enrolment in this state - of - the - art teaching and learning environment had reached an impressive 5,000.`,

    //     `About a year later, on 29 June 2000, the Malaysia Prime Minister, Tun Dr.Mahathir Mohamad officially opened the UNITEN Putrajaya campus.`,

    //     `This further spurred the university to reach greater heights which saw it move from strength to strength consolidating its stature as a university of choice.That same year also saw the first intake of students in UNITEN’s very own bachelor’s degree programme.`,
    // ]
    return (
        <div className="flex flex-col gap-5 ">
            <h1 className="w-auto max-w-[30ch] text-3xl font-bold text-slate-900  2xl:text-5xl !leading-tight">{title}</h1>
            <p className='w-auto whitespace-pre-line'>{description}</p>

            {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {
                    images.map((img, i) => (
                        <img key={i} src={img} className="w-full bg-gray-100 h-auto max-h-[15rem] object-cover aspect-square bg-center rounded-lg  bg-cover bg-no-repeat italic" alt="photo" />
                    ))
                }
            </div>
            {
                paragraphs.map((p, i) => (
                    <p key={i} className="w-auto  text-justify   text-base font-normal leading-normal">{p}</p>
                ))
            } */}
        </div>
    )
}
History.propTypes = {
    url: PropTypes.string
}
export default History